import { createSlice } from '@reduxjs/toolkit';

const MarqueDetailsDataSlice = createSlice({
    name: 'MarqueDetailsData',
    initialState: '',
    reducers: {
        setMarqueDetailsData: (state, action) => {
            return action.payload;
        },
        resetMarqueDetailsData: (state) => {
            return null;
        },
    },
});

export const { setMarqueDetailsData, resetMarqueDetailsData } = MarqueDetailsDataSlice.actions;
export default MarqueDetailsDataSlice.reducer;